const getters = {
    getToken: state => {
        return state.token ? state.token : sessionStorage.getItem("token")
    },
    getCourtName: state => {
        // 法院名字
        return state.courtName ? state.courtName : sessionStorage.getItem("courtName")
    },
    getUsername: state => {
        return state.username ? state.username : sessionStorage.getItem("username")
    },
    getJobNumber: state => {
        return state.jobNumber ? state.jobNumber : sessionStorage.getItem("jobNumber")
    },
    getWindow: state => {
        return state.window ? state.window : sessionStorage.getItem("window")
    },
    getService: state => {
        return state.service ? state.service : sessionStorage.getItem("service")
    },
    getQueueno: state => {
        return state.queueno ? state.queueno : sessionStorage.getItem("queueno")
    },

}
export default getters